import Helper from './Helper';
import * as API from './../Constants/api';

class TeamLoader {
	constructor(config = {}) {
		const {type, buttonSelector, buttonDataAttribute} = config;

		this.toggler = document.querySelector(buttonSelector);
		this.buttonDataAttribute = buttonDataAttribute;
		this.type = type;

		if (this.toggler) {
			this.bindEvents();
		}
	}

	bindEvents() {
		this.toggler.addEventListener('click', e => {
			if (!document.querySelector('.loading-wrapper')) {
				this.createPopup();
				const data = Helper.camelCase(this.buttonDataAttribute);
				const dataValue = this.toggler.dataset[data];
				this.getTeam(dataValue);
				Helper.addClass(document.body, 'popup-open');
				Helper.addClass(this.popup, 'visible');
			}
		});
	}

	getTeam(postID) {
		let APIbase = API.posts;
		if (this.type == 'cases') {
			APIbase = API.cases;
		}
		let fetchURL = `${APIbase}${postID}`;
		//console.log(fetchURL);
		fetch(fetchURL, {
			mode: 'same-origin' // no-cors, cors, *same-origin
		})
			.then(this.handleErrors)
			.then(response => {
				return response.json();
			})
			.then(data => {
				const team = data.acf.connection_projects;

				team.forEach((member, i) => {
					this.getMember(member.post_type, member.ID, i, team.length);
				});
			})
			.catch(err => {
				//console.log(err);
			});
	}

	getMember(postType, memberID, i, total) {
		let fetchURL = `${API.base}${postType}/${memberID}`;
		//console.log(fetchURL);
		fetch(fetchURL, {
			mode: 'same-origin' // no-cors, cors, *same-origin
		})
			.then(this.handleErrors)
			.then(response => {
				return response.json();
			})
			.then((data) => {
				const department = data.acf.employee_department.name;
				const imgID = data.acf.employee_image;
				const linkedIn = data.acf.employee_linkedin;
				const name = data.title.rendered;
				const efunction = data.acf.employee_function;
				const mail = data.acf.employee_email;
				const phone = data.acf.employee_telephone;
				const active = data.acf.employee_active;
				// Helper.addClass(document.querySelector('.popup__content'), 'hidden');
				if (active == true ) {
					document.querySelector('.popup__inner').innerHTML += `
					<div class="popup__post popup__post--employee">
						<div class="employees__employee">
						<div class="employees__employee-department">${department}</div>
						<div class="employees__employee-image" data-employee-img-id="${imgID}">
							<img alt="member image" class="employee-img">
							<a class="employees__employee-linkedin" href="${linkedIn}" target="_blank">
								<i class="nhs-icon"><svg class="icon icon-linkedin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44"><path d="M44 27.7V44h-9.4V28.8c0-3.8-1.4-6.4-4.8-6.4-2.6 0-4.2 1.8-4.8 3.4-.2.6-.3 1.5-.3 2.3V44h-9.4s.1-25.7 0-28.4h9.4v4s0 .1-.1.1h.1v-.1c1.3-1.9 3.5-4.7 8.5-4.7C39.3 15 44 19 44 27.7zM5.3 2C2.1 2 0 4.1 0 6.9c0 2.7 2 4.9 5.2 4.9h.1c3.3 0 5.3-2.2 5.3-4.9-.1-2.8-2-4.9-5.3-4.9zM.6 44H10V15.6H.6V44z" fill="currentColor"></path></svg></i>
							</a>
						</div>
						<div class="employees__employee-content">
							<div class="employees__employee-name">
								<h2 class="employees__employee-title">${name}</h2>
							</div>
							<div class="employees__employee-function">${efunction}</div>
							<div class="employees__employee-contact">
								<div class="employees__employee-email">
									<a class="employees__employee-link employees__employee-link--email" href="mailto:${mail}">
										<span class="employees__employee-icon">
											<i class="nhs-icon"><svg version="1.1" id="Ebene_1" class="icon icon-mail" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 44 44" xml:space="preserve"><style>#Ebene_1 .st0{fill:currentColor}#Ebene_1 .st1{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}</style><path class="st0" d="M22 2c11 0 20 9 20 20s-9 20-20 20S2 33 2 22 11 2 22 2m0-2C9.8 0 0 9.8 0 22s9.8 22 22 22 22-9.8 22-22S34.2 0 22 0z"></path><path class="st0" d="M32.5 14v16h-21V14h21m.6-2H10.9c-.7 0-1.4.6-1.4 1.4v17.3c0 .7.6 1.4 1.4 1.4h22.3c.7 0 1.4-.6 1.4-1.4V13.4c-.1-.8-.7-1.4-1.5-1.4z"></path><path class="st1" d="M13.5 16l8.5 8.5 8.5-8.5M30 27.8l-3-3M14 27.8l3-3"></path></svg></i>
										</span>
										<span class="employees__employee-text">
											${mail}
										</span>
									</a>
								</div>
								<div class="employees__employee-phone">
									<a class="employees__employee-link employees__employee-link--phone" href="tel:${phone}">
										<span class="employees__employee-icon">
											<i class="nhs-icon"><svg version="1.1" id="Ebene_1" class="icon icon-phone" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 44 44" xml:space="preserve"><style>#Ebene_1 .st1{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}</style><path class="st0" d="M22 2c11 0 20 9 20 20s-9 20-20 20S2 33 2 22 11 2 22 2m0-2C9.8 0 0 9.8 0 22s9.8 22 22 22 22-9.8 22-22S34.2 0 22 0z" fill="currentColor"></path><path class="st1" d="M28.7 25.7l-2.6 2.6c-.3.3-1-.1-1.6-.3-3.4-1.3-8.2-6.1-9.4-9.5-.2-.5-.6-1.2-.3-1.5l2.6-2.6-4.9-4.9-3.2 3.2c-1.1 1.1-1.1 2.5-.6 3.5 2.2 6.4 11.8 15.7 18 18.1 1 .4 2.7.6 3.8-.5l3.2-3.2-5-4.9zM23.9 11.2c4.4 0 8 3.6 8 8M23.9 14.4c2.6 0 4.8 2.1 4.8 4.8M23.9 17.7c.8 0 1.5.7 1.5 1.5"></path></svg></i>
										</span>
										<span class="employees__employee-text">
											${phone}
										</span>
									</a>
								</div>
								<div class="employees__employee-linkedin-alt">
									<a class="employees__employee-link employees__employee-link--linkedin" href="tel:${linkedIn}">
										<span class="employees__employee-icon">
											<i class="nhs-icon"><svg version="1.1" id="Ebene_1" class="icon icon-linkedin--circle" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 44 44" xml:space="preserve"><style>#Ebene_1 .st0{fill:currentColor}</style><path class="st0" d="M22 2c11 0 20 9 20 20s-9 20-20 20S2 33 2 22 11 2 22 2m0-2C9.8 0 0 9.8 0 22s9.8 22 22 22 22-9.8 22-22S34.2 0 22 0z"></path><path id="LinkedIn" class="st0" d="M31 23.9v6.7h-3.9v-6.2c0-1.6-.6-2.6-2-2.6-1.1 0-1.7.7-2 1.4-.1.2-.1.6-.1.9v6.5h-3.9s.1-10.5 0-11.6H23v1.6c.5-.8 1.4-1.9 3.5-1.9 2.6 0 4.5 1.7 4.5 5.2zM15.2 13.4c-1.3 0-2.2.9-2.2 2s.8 2 2.1 2 2.2-.9 2.2-2-.8-2-2.1-2zm-2 17.2h3.9V19h-3.9v11.6z"></path></svg></i>
										</span>
									</a>
								</div>
							</div>
						</div>
					</div>
					</div>
					`;
					this.getMemberImage(imgID, i, total);
				}
			})
			.catch(err => {
				//console.log(err);
			});
	}

	getMemberImage(imageID, i, total) {
		let fetchURL = `${API.media}${imageID}`;
		//console.log(fetchURL);
		fetch(fetchURL, {
			mode: 'same-origin' // no-cors, cors, *same-origin
		})
			.then(this.handleErrors)
			.then(response => {
				return response.json();
			})
			.then(data => {
				const img = document.querySelector(`[data-employee-img-id="${imageID}"] img`);
				if (data.media_details.sizes.medium.source_url) {
					img.src = data.media_details.sizes.medium.source_url;
				} else {
					img.src = '';
				}
				Helper.addClass(img.parentElement.parentElement, 'visible');
				Helper.addClass(img.parentElement.parentElement, 'fade-in-up');
				Helper.addClass(document.querySelector(`.popup .loading-wrapper`), 'hidden');
				Helper.addClass(document.querySelector(`.popup .popup__title`), 'visible');
			})
			.catch(err => {
				//console.log(err);
			});
	}

	createPopup() {
		if (this.popup != undefined) {

		} else {
			var elem = document.createElement('div');
			Helper.addClass(elem, 'team-popup');
			Helper.addClass(elem, 'popup');
			elem.innerHTML = '<div class="popup__close"><span class="popup__close-icon"></span><span class="popup__closer">Schliessen</span></div>';
			document.body.appendChild(elem);
			elem.innerHTML += `<div class="popup__title">Projektteam</div>`;
			elem.innerHTML += `<div class="loading-wrapper"><div class="loading-wrapper__spinner"></div></div><div class="popup__content"><div class="popup__inner"></div></div>`;
			this.popup = document.querySelector('.team-popup');
			this.popup.animate([
				// keyframes
				{
					opacity: 0
				},
				{
					opacity: 1
				}
			], {
				// timing options
				duration: 400,
				iterations: 1
			});
		}

		document.body.addEventListener('keyup', e => {
			if (e.keyCode == 27) {
				// //console.log('esc');
				this.killPopup();
			}
		});

		document.querySelector('.popup .popup__close').addEventListener('click', e => {
			this.killPopup();
		});
	}

	killPopup() {
		this.popup.animate([
			// keyframes
			{
				opacity: 1
			},
			{
				opacity: 0
			}
		], {
			// timing options
			duration: 400,
			iterations: 1
		});
		setTimeout(() => {
			this.popup.innerHTML = '';
			this.popup.remove();
			this.popup = undefined;
			Helper.removeClass(document.body, 'popup-open');
		}, 400);
	}
}

export default TeamLoader;
